module.exports = __webpack_public_path__ + "img/bd.4063fc21.webp";